import { render } from "./NieuwsArtikel.vue?vue&type=template&id=5df3792a&scoped=true"
import script from "./NieuwsArtikel.vue?vue&type=script&lang=js"
export * from "./NieuwsArtikel.vue?vue&type=script&lang=js"

import "./NieuwsArtikel.vue?vue&type=style&index=0&id=5df3792a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df3792a"]])

export default __exports__